import { ERR_REPORTS, GET_CAMP_COLL_OFF, GET_REPORTS, LOADING_REPORTS } from "../actions/actionTypes";

const initialState = {
	reports: [],
	campCollOffList: [],
	loading: false,
	errors: {},
};

export default function reportReducer(state = initialState, action) {
	const { type, payload } = action;

	switch (type) {
		case GET_REPORTS:
			return {
				...state,
				reports: payload,
				errors: {},
				loading: false,
			};
		case GET_CAMP_COLL_OFF:
			return {
				...state,
				campCollOffList: payload,
				errors: {},
				loading: false,
			};
		case ERR_REPORTS:
			return {
				...state,
				errors: payload,
				loading: false
			};
		case LOADING_REPORTS:
			return {
				...state,
				loading: payload
			};
		default:
			return state;
	}
}
